module.exports = [
    require('./paragraph'),
    require('./header')
];